import { BarChart3, CalendarRange, Target } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import GuestStudyProgressOverview from "@/app/my/GuestStudyProgressOverview";

/**
 * 비로그인(게스트) 공부 진행상황 탭에 흐리게 깔 정적 목업 (JCG — 학습 탭 게스트 프리뷰).
 *
 * 실제 콘텐츠(StudyProgressPage 전체 탭)의 시각 골격(전체 현황 진도 바 + 정답률 통계 박스)을
 * 더미 데이터로 본뜬 presentational 컴포넌트. fetch/훅 없음. `GuestPreviewOverlay` 가 통째로
 * aria-hidden + blur 처리하므로 여기선 시각 골격만 신경 쓴다.
 * "전체 현황" 카드 내부 콘텐츠는 `GuestDashboardPreview`와 공유하는
 * `GuestStudyProgressOverview` 로 추출됨(단일 소스, 시각 동일).
 */

export default function StudyProgressGuestMock() {
  return (
    <div className="px-2 py-3">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="flex items-center text-xl font-bold text-foreground">
          <BarChart3 className="mr-2 h-5 w-5" />
          공부 진행상황
        </h2>
      </div>

      {/* 학습 계획 온트랙 카드 자리(JCG-2310) — 로그인 시 StudyPlanOnTrackCard 가 차지하는
          위치를 정적으로 미러링해 비로그인 블러 프리뷰가 어긋나지 않게 한다. fetch/훅 없음.
          GuestPreviewOverlay 가 통째로 aria-hidden + blur 처리하므로 시각 골격만 신경 쓴다. */}
      <Card className="mb-6">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between gap-2">
            <CardTitle className="flex items-center gap-2 text-base">
              <CalendarRange className="h-4 w-4 text-amber-500" />
              학습 계획 진행 상태
            </CardTitle>
            <span className="text-xs font-medium text-muted-foreground">
              일정 관리 ›
            </span>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2.5">
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <span className="rounded-full bg-blue-50 px-2 py-0.5 text-[11px] font-bold text-blue-700 dark:bg-blue-950/50 dark:text-blue-300">
                이론 4주 완성
              </span>
              <span className="text-[11px] font-medium text-muted-foreground tabular-nums">
                Day 3/28
              </span>
              <span className="ml-auto flex items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-[11px] font-semibold text-green-700 dark:bg-green-900/30 dark:text-green-300">
                  🟢 순항 중
                </span>
                <span className="text-[11px] font-bold text-muted-foreground tabular-nums">
                  D-25
                </span>
              </span>
            </div>
            <div className="pt-3.5">
              <div className="relative h-2.5 w-full rounded-full bg-muted">
                <div className="absolute inset-y-0 left-0 w-[14%] rounded-full bg-amber-500 dark:bg-amber-400" />
              </div>
            </div>
            <div className="flex items-center justify-between text-[11px] text-muted-foreground">
              <span>완료 12 / 예정 12(오늘까지)</span>
              <span className="tabular-nums">전체 12/98 (12%)</span>
            </div>
            <p className="rounded-lg bg-muted/60 px-3 py-2 text-xs text-muted-foreground">
              남은 86개 · 시험까지 25일 → 하루 4개면 완주 ✓
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base">
            <Target className="h-4 w-4" />
            전체 현황
          </CardTitle>
        </CardHeader>
        <CardContent>
          <GuestStudyProgressOverview />
        </CardContent>
      </Card>
    </div>
  );
}
